<template>
  <b-modal
    v-if="isOpen"
    v-model="isOpen"
    no-close-on-backdrop
    centered
    size="lg"
    :title="`Reintegrar o produto '${
      (productIntegration.product || {}).produto
    }'`"
    :loading="loading"
  >
    <b-overlay :show="loading" rounded="sm">
      <b-row v-if="Object.keys(requestPayload).length">
        <b-col>
          <product-card
            is-selected
            hide-checkbox
            :product="{
              ...productIntegration.product,
              ...requestPayload,
            }"
            @update-price="requestPayload.price = $event"
            @update-category="requestPayload.categoryId = $event"
            @update-attributes="requestPayload.attributes = $event"
          />
        </b-col>
      </b-row>
    </b-overlay>
    <template #modal-footer>
      <b-btn variant="outline-danger" :disabled="loading" @click="close">
        <i class="far fa-times-circle mr-2"></i>Cancelar
      </b-btn>
      <b-btn variant="success" @click="reintegrateProduct" :disabled="loading">
        <i class="fas fa-sync mr-2"></i>Reintegrar
      </b-btn>
    </template>
  </b-modal>
</template>

<script>
import shopkeeperAppApi from '@/api/shopkeeperAppApi';
import makeToast from '@/mixins/makeToast';
import IntegrationTypes from 'Enums/Integration/IntegrationTypes';

import BaseModal from '@/components/Modal/BaseModal.vue';
import ProductCard from './ProductCard.vue';
import { mapState } from 'vuex';

export default {
  name: 'ReintegrationModal',
  emits: ['reintegrated'],
  mixins: [makeToast],
  data() {
    return {
      isOpen: false,
      loading: false,
      productIntegration: {},
      requestPayload: {
        productId: 0,
        price: '',
        categoryId: '',
        attributes: [],
      },
    };
  },
  computed: {
    ...mapState(['dadosUsuario']),
  },
  methods: {
    async reintegrateProduct() {
      try {
        this.loading = true;

        await shopkeeperAppApi.post(
          `/integration/marketplace/retry-publish-product?integrationType=${IntegrationTypes.MERCADO_LIVRE}&construpUserId=${this.dadosUsuario.id}`,
          {
            product: {
              ...this.requestPayload,
            },
          }
        );

        this.makeToast(
          'Sucesso',
          `O produto ${
            (this.productIntegration.product || {}).produto
          } foi adicionado a fila de integração novamente`
        );

        this.$emit('reintegrated');
        this.close();
      } catch (ex) {
        this.makeToast(
          'Erro',
          `Houve um erro ao realizar a integração: ${ex.message}`,
          'danger'
        );
      } finally {
        this.loading = false;
      }
    },
    open(productIntegration = {}) {
      this.isOpen = true;
      this.productIntegration = productIntegration;

      if (!Object.keys(productIntegration).length) return;

      const productPayloadDecoded = this.handlePayload(productIntegration);

      this.requestPayload = {
        productId: productPayloadDecoded.productId,
        price: productPayloadDecoded.price,
        categoryId: productPayloadDecoded.categoryId,
        attributes: {},
      };
    },
    close() {
      this.isOpen = false;
      this.productIntegration = {};
      this.requestPayload = {};
    },
    handlePayload(productIntegration) {
      if (!productIntegration || !productIntegration.payload) return;

      return JSON.parse(productIntegration.payload);
    },
  },
  components: {
    BaseModal,
    ProductCard,
  },
};
</script>
